<nz-select
  [nzPlaceHolder]="'SELECT_DATE_RANGE' | translate"
  nzAllowClear
  [(ngModel)]="selected"
  (ngModelChange)="selectedDateChanged($event)"
  (nzOpenChange)="openChange($event)"
  [nzCustomTemplate]="customTpl"
  nzSize="large"
  [ngStyle]="{'width.px': width}"
>
  <nz-option nzCustomContent [nzLabel]="'DATES_ORDER.CUSTOM' | translate" nzValue="custom">
    <div (change)="openRangePicker()">
      <i nz-icon nzType="edit" nzTheme="outline"></i> {{ 'DATES_ORDER.CUSTOM' | translate }}
    </div>
  </nz-option>
  <nz-option
    *ngFor="let date of dateSelectOptions"
    [nzValue]="date?.id"
    [nzLabel]="date?.name"
  ></nz-option>
</nz-select>
<ng-template #customTpl let-selected>
  <div class="trigger-title">
    <span class="fs-14 fw-600">{{ selected.nzLabel }}</span>
    <span class="date_range">{{ dateRangeText }}</span>
  </div>
</ng-template>

<div #customDateWrapper class="range-picker">
  <date-range #customDate [disableDate]="disabledDate" (dateRangeSelected)="onChange($event)"></date-range>
</div>
